import { Env } from "../../env";
import { ApiClient } from "../../http/api_client";

const REFINEMENT_TYPE_BALLPOINTPEN_REPLACEMENTCORE = 1;
const REFINEMENT_LEVEL_ONE = 1;
const REFINEMENT_LEVEL_TWO = 2;
const REFINEMENT_LEVEL_THREE = 3;

export class BallPointPenRepository {
  private async getBallPointPens(refinementLevel: number, refinementCondition1: string, refinementCondition2: string): Promise<string[]> {
    const ballPointPens = await ApiClient.get(
      Env.SETTING.userPublicApi.urlBase + 'api/attract/search/refinementSearchElements/',
      {
        params: {
          refinementType: REFINEMENT_TYPE_BALLPOINTPEN_REPLACEMENTCORE,
          refinementLevel,
          refinementCondition1,
          refinementCondition2
        }
      });

    return ballPointPens.refinementSearchElements.map((refinementSearchElement: { refinementSearchDisplayName: string; }) =>
      refinementSearchElement.refinementSearchDisplayName
    )
  }

  getBallPointPenMakers() {
    return this.getBallPointPens(REFINEMENT_LEVEL_ONE, '', '');
  }

  getBallPointPenSeries(selectedMaker: string) {
    return this.getBallPointPens(REFINEMENT_LEVEL_TWO, selectedMaker, '');
  }

  getBallPointPenSizes(selectedMaker: string, selectedSeries: string) {
    return this.getBallPointPens(REFINEMENT_LEVEL_THREE, selectedMaker, selectedSeries);
  }
}
